import { GLTFLoader } from "three-stdlib";
import { DRACOLoader, KTX2Loader } from "three-stdlib";
import type { WebGLRenderer } from "three";

/**
 * Configuración de loaders GLTF con Draco y KTX2.
 * Los decoders se servirán desde /public/draco y /public/basis cuando
 * haya activos comprimidos; por ahora los loaders quedan listos y sin
 * descargas externas.
 */
const DRACO_PATH = "/draco/";
const BASIS_PATH = "/basis/";

let sharedDraco: DRACOLoader | null = null;

function getDracoLoader(): DRACOLoader {
  if (!sharedDraco) {
    sharedDraco = new DRACOLoader();
    sharedDraco.setDecoderPath(DRACO_PATH);
  }
  return sharedDraco;
}

export function createGltfLoader(renderer?: WebGLRenderer): GLTFLoader {
  const loader = new GLTFLoader();
  loader.setDRACOLoader(getDracoLoader());

  if (renderer) {
    const ktx2 = new KTX2Loader();
    ktx2.setTranscoderPath(BASIS_PATH);
    ktx2.detectSupport(renderer);
    loader.setKTX2Loader(ktx2);
  }

  return loader;
}
